import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

import { findProductByUrlName } from '@/utils/productData';

import OnboardingQuestions from '@/components/forms/OnboardingQuestions.vue';

//forms
import WeightLoss from '@/components/forms/WeightLoss.vue';
import FormLoader from '@/components/forms/FormLoader.vue';
import WeightLossFlowTwo from '@/components/WeightLoss/WeightLossFlowTwo.vue';

import AskQuestions from '@/components/forms/TelegraFormStepLoader.vue';


import reportPage from '@/components/WeightLoss/reportPage.vue';
import choosePlan from '@/components/WeightLoss/choosePlan.vue';

//medical forms
import FullMedicalForm from '@/components/forms/FullMedicalForm.vue';
import AppThanks from '@/components/common/appointmentThanks.vue';
import AsyncThanks from '@/components/common/asyncThanks.vue';
import Calendar from '@/components/calendar/CalanderMain.vue';

import MedicalFormThanks from '@/components/common/asyncThankYouPage.vue';
//import CareCalendar from '@/components/calendarCare/CalanderMain.vue';
//import CareThanks from '@/components/common/careThanks.vue';

//sorry page
import leadDisqualified from '@/components/common/leadDisqualified.vue';

//product and shop
import productTemplate from '@/components/product/productTemplate.vue';
//import ShopPage  from '@/components/shop/ShopPage.vue';
import Store  from '@/components/shop/storePage.vue';
//payments

import checkoutMainComponent from '@/components/checkouts/checkoutMainComponent.vue';
//import PaymentThanks from '@/components/checkouts/PaymentThanks.vue';
import prescriptionThanks from '@/components/WeightLoss/WeightLossAfterCheckout.vue';

import checkOutStyleOne from '@/components/checkouts/checkOutStyleOne.vue';
import checkoutWeightLoss from '@/components/checkouts/checkoutWeightLoss.vue';

//auth
import LoginPage from '@/components/auth/LoginPage.vue';
import ResetPassword from '@/components/auth/ResetPassword.vue'
import ForgotPassword from '@/components/auth/ForgotPassword.vue'

//dashboard

import HomePage from '@/components/dashboard/HomePage.vue'
import medIntegration from '@/components/forms/medIntegration.vue';

Vue.use(Router)

const router = new Router({
  mode: 'history',
  hash: false,
  scrollBehavior(to, from, savedPosition) {
    // If there's a saved scroll position (like after navigating back), use it
    if (savedPosition) {
      return savedPosition;
    } else {
      // Otherwise, scroll to the top
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: '/',
      name: 'WeightLossFlowTwoHome',
      component: WeightLossFlowTwo,
      meta: {
        requiresAuth: false,
        guest: true
      }
      
    },
    {
      path: '/quiz',
      name: 'OnboardingQuestions',
      component: OnboardingQuestions,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/get-in-shape',
      name: 'WeightLossFlowTwo',
      component: WeightLossFlowTwo,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/weight-loss-report',
      name: 'reportPage',
      component: reportPage,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/weight-loss-plan',
      name: 'choosePlan',
      component: choosePlan,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/weightloss',
      component: { render(c) { return c('router-view') } }, // Wrapper for nested routes
      children: [
        {
          path: 'initial',
          name: 'FullMedicalForm',
          component: FullMedicalForm,
          props: true,
          meta: {
            requiresAuth: true,
            guest: false
          }
        },
        {
          path: '/glp1',
          name: 'WeightLoss',
          component: WeightLoss,
          props: true,
          meta: {
            requiresAuth: false,
            guest: true
          }
        },
        {
          path: 'accepted',
          name: 'MedicalFormThanks',
          component: MedicalFormThanks,
          props: true,
          meta: {
            requiresAuth: true,
            guest: false
          }
        }
      ]
    },
    { //
      path: '/questionnaire/:id',
      name: 'AskQuestions',
      component: AskQuestions,
      props: true,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/assessment/:id',
      name: 'FormLoader',
      component: FormLoader,
      props: true,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/store',
      name: 'Store',
      component: Store,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    /*{
      path: '/shop',
      name: 'ShopPage',
      component: ShopPage,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },*/
    {
      path: '/schedule',
      name: 'Calendar',
      component: Calendar,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    
    {
      path: '/schedule/thanks',
      name: 'AppThanks',
      component: AppThanks,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },

    {
      path: '/submitted',
      name: 'AsyncThanks',
      component: AsyncThanks,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/home',
      name: 'HomePage',
      component: HomePage,
      meta: {
        requiresAuth: true,
        guest: true
      }
    },
    {
      path: '/sorry',
      name: 'leadDisqualified',
      component: leadDisqualified,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/payments',
      name: 'checkOutStyleOne',
      component: checkOutStyleOne,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/payment',
      name: 'Checkouts',
      component: checkoutMainComponent,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/payment/thanks',
      name: 'prescriptionThanks',
      component: prescriptionThanks,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/case-questions/:id',
      name: 'medIntegration',
      component: medIntegration,
      props: true,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/weight-loss-payment/:cart_id',
      name: 'checkoutWeightLoss',
      component: checkoutWeightLoss,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/product/:productName',
      name: 'productPage',
      component: productTemplate,
      meta: {
        requiresAuth: false,
        guest: true
      },
      beforeEnter: (to, from, next) => {
        console.log("Before Enter Product Route");
        console.log("Product Name from URL:", to.params.productName);

        const product = findProductByUrlName(to.params.productName);
        console.log("Found Product:", product);

        if (product) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.authToken == null) {
      // Add the page_ref query parameter with the route name the user was trying to access
      next({
        path: '/login',
        query: {
          page_ref: to.fullPath,
        }
      });
    } else {
      next();
    }
  } else {
    next();
  }
})

export default router;
